<template>
  <div class="loading">
    <img src="./../assets/img/loading.gif" alt />
  </div>
</template>
 
<script>
export default {
  name: "Loading",
  data() {
    return {};
  }
};
</script>
<style scoped>
.loading {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 121;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.3);
    display: table-cell;
    vertical-align: middle;
    text-align: center;
}
.loading img {
    width: 0.6rem;
    height: 0.24rem;
    position: absolute;
    left: 50%;
    top: 50%;
    margin: 0 !important;
    margin-top: -0.12rem !important;
    margin-left: -0.3rem !important;
}
</style>